/**
 * Per-event enrollments — driver_name / vehicle / device_id for every
 * device that's joined the event (any state). The public viewer uses
 * this to show display names in the Compare picker for finished cars
 * that aren't in `useEventLiveDevices` anymore.
 *
 * One-shot fetch on mount + refetch every 60 s; updates are slow
 * (manual admin approval) so polling cadence is forgiving.
 */

import { useEffect, useState } from 'react';

import { EnrollmentRow, listEnrollments } from '../services/fleet';

const REFRESH_MS = 60_000;

export function useEventEnrollments(eventId: number | null): EnrollmentRow[] {
  const [rows, setRows] = useState<EnrollmentRow[]>([]);
  useEffect(() => {
    if (eventId == null) {
      setRows([]);
      return;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const data = await listEnrollments(eventId);
        if (!cancelled) setRows(data);
      } catch (err) {
        console.warn('[useEventEnrollments] fetch failed', err);
      }
    };
    void load();
    const id = window.setInterval(() => {
      void load();
    }, REFRESH_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [eventId]);
  return rows;
}
